// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__bWPmj","log":"ModalInventoryLogs_log__3SK7_","date":"ModalInventoryLogs_date__1fgKS","userName":"ModalInventoryLogs_userName__2oATR"};